/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateBulkSalesLeadResponse } from '../models';
// @ts-ignore
import type { CreateCallAttemptBody } from '../models';
// @ts-ignore
import type { CreateSalesLeadBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllSalesLeadsJobsResponse } from '../models';
// @ts-ignore
import type { GetAllSalesLeadsResponse } from '../models';
// @ts-ignore
import type { GetCallAttemptListResponse } from '../models';
// @ts-ignore
import type { GetCallAttemptResponse } from '../models';
// @ts-ignore
import type { GetSalesExcutiveSub } from '../models';
// @ts-ignore
import type { GetSalesLeadResponse } from '../models';
// @ts-ignore
import type { GetSalesMailSentListResponse } from '../models';
// @ts-ignore
import type { GetsalesExecutiveListResponse } from '../models';
// @ts-ignore
import type { SalesLeadSignUpResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateSalesLeadBody } from '../models';
/**
 * SalesApiApi - axios parameter creator
 */
export const SalesApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<CreateSalesLeadBody>} createSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateBulkSalesLead: async (createSalesLeadBody: Array<CreateSalesLeadBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSalesLeadBody' is not null or undefined
            assertParamExists('salesApiCreateBulkSalesLead', 'createSalesLeadBody', createSalesLeadBody)
            const localVarPath = `/sales-lead/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesLeadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {CreateCallAttemptBody} createCallAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateCallAttempt: async (salesLeadId: string, createCallAttemptBody: CreateCallAttemptBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiCreateCallAttempt', 'salesLeadId', salesLeadId)
            // verify required parameter 'createCallAttemptBody' is not null or undefined
            assertParamExists('salesApiCreateCallAttempt', 'createCallAttemptBody', createCallAttemptBody)
            const localVarPath = `/sales-lead/{sales_lead_id}/call-attempt`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCallAttemptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSalesLeadBody} createSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateSalesLead: async (createSalesLeadBody: CreateSalesLeadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSalesLeadBody' is not null or undefined
            assertParamExists('salesApiCreateSalesLead', 'createSalesLeadBody', createSalesLeadBody)
            const localVarPath = `/sales-lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesLeadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiDeleteSalesLeadById: async (salesLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiDeleteSalesLeadById', 'salesLeadId', salesLeadId)
            const localVarPath = `/sales-lead/{sales_lead_id}`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiEmailToSalesLead: async (salesLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiEmailToSalesLead', 'salesLeadId', salesLeadId)
            const localVarPath = `/sales-lead/{sales_lead_id}/signup-mail`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [phoneNumber] 
         * @param {string} [salesLeadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetCallAttemptList: async (page?: number, pageSize?: number, phoneNumber?: string, salesLeadId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/call-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (salesLeadId !== undefined) {
                localVarQueryParameter['sales_lead_id'] = salesLeadId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesExcutiveList: async (name?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/sales-excutives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesExec: async (salesUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-executive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (salesUserId !== undefined) {
                localVarQueryParameter['sales_user_id'] = salesUserId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadById: async (salesLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiGetSalesLeadById', 'salesLeadId', salesLeadId)
            const localVarPath = `/sales-lead/{sales_lead_id}`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadJobDetailsList: async (salesLeadId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiGetSalesLeadJobDetailsList', 'salesLeadId', salesLeadId)
            const localVarPath = `/sales-lead/{sales_lead_id}/jobs`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {string} [salesLeadType] 
         * @param {string} [salesUserId] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadList: async (maxDate?: string, minDate?: string, page?: number, pageSize?: number, query?: string, salesLeadType?: string, salesUserId?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (salesLeadType !== undefined) {
                localVarQueryParameter['sales_lead_type'] = salesLeadType;
            }

            if (salesUserId !== undefined) {
                localVarQueryParameter['sales_user_id'] = salesUserId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [salesLeadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesMailSentList: async (email?: string, page?: number, pageSize?: number, salesLeadId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sales-lead/mail-sent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (salesLeadId !== undefined) {
                localVarQueryParameter['sales_lead_id'] = salesLeadId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} callAttemptId 
         * @param {string} salesLeadId 
         * @param {CreateCallAttemptBody} createCallAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiUpdateCallAttempt: async (callAttemptId: string, salesLeadId: string, createCallAttemptBody: CreateCallAttemptBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callAttemptId' is not null or undefined
            assertParamExists('salesApiUpdateCallAttempt', 'callAttemptId', callAttemptId)
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiUpdateCallAttempt', 'salesLeadId', salesLeadId)
            // verify required parameter 'createCallAttemptBody' is not null or undefined
            assertParamExists('salesApiUpdateCallAttempt', 'createCallAttemptBody', createCallAttemptBody)
            const localVarPath = `/sales-lead/{sales_lead_id}/call-attempt/{call_attempt_id}`
                .replace('{call_attempt_id}', encodeURIComponent(String(callAttemptId)))
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCallAttemptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {UpdateSalesLeadBody} updateSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiUpdateSalesLeadById: async (salesLeadId: string, updateSalesLeadBody: UpdateSalesLeadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesLeadId' is not null or undefined
            assertParamExists('salesApiUpdateSalesLeadById', 'salesLeadId', salesLeadId)
            // verify required parameter 'updateSalesLeadBody' is not null or undefined
            assertParamExists('salesApiUpdateSalesLeadById', 'updateSalesLeadBody', updateSalesLeadBody)
            const localVarPath = `/sales-lead/{sales_lead_id}`
                .replace('{sales_lead_id}', encodeURIComponent(String(salesLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesLeadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesApiApi - functional programming interface
 */
export const SalesApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<CreateSalesLeadBody>} createSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiCreateBulkSalesLead(createSalesLeadBody: Array<CreateSalesLeadBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBulkSalesLeadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiCreateBulkSalesLead(createSalesLeadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiCreateBulkSalesLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {CreateCallAttemptBody} createCallAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiCreateCallAttempt(salesLeadId: string, createCallAttemptBody: CreateCallAttemptBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiCreateCallAttempt(salesLeadId, createCallAttemptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiCreateCallAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSalesLeadBody} createSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiCreateSalesLead(createSalesLeadBody: CreateSalesLeadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesLeadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiCreateSalesLead(createSalesLeadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiCreateSalesLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiDeleteSalesLeadById(salesLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiDeleteSalesLeadById(salesLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiDeleteSalesLeadById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiEmailToSalesLead(salesLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesLeadSignUpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiEmailToSalesLead(salesLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiEmailToSalesLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [phoneNumber] 
         * @param {string} [salesLeadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetCallAttemptList(page?: number, pageSize?: number, phoneNumber?: string, salesLeadId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallAttemptListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetCallAttemptList(page, pageSize, phoneNumber, salesLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetCallAttemptList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesExcutiveList(name?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetsalesExecutiveListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesExcutiveList(name, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesExcutiveList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [salesUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesExec(salesUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesExcutiveSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesExec(salesUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesExec']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesLeadById(salesLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesLeadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesLeadById(salesLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesLeadById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesLeadJobDetailsList(salesLeadId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllSalesLeadsJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesLeadJobDetailsList(salesLeadId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesLeadJobDetailsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {string} [salesLeadType] 
         * @param {string} [salesUserId] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesLeadList(maxDate?: string, minDate?: string, page?: number, pageSize?: number, query?: string, salesLeadType?: string, salesUserId?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllSalesLeadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesLeadList(maxDate, minDate, page, pageSize, query, salesLeadType, salesUserId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesLeadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [salesLeadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiGetSalesMailSentList(email?: string, page?: number, pageSize?: number, salesLeadId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesMailSentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiGetSalesMailSentList(email, page, pageSize, salesLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiGetSalesMailSentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} callAttemptId 
         * @param {string} salesLeadId 
         * @param {CreateCallAttemptBody} createCallAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiUpdateCallAttempt(callAttemptId: string, salesLeadId: string, createCallAttemptBody: CreateCallAttemptBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiUpdateCallAttempt(callAttemptId, salesLeadId, createCallAttemptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiUpdateCallAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} salesLeadId 
         * @param {UpdateSalesLeadBody} updateSalesLeadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesApiUpdateSalesLeadById(salesLeadId: string, updateSalesLeadBody: UpdateSalesLeadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesLeadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesApiUpdateSalesLeadById(salesLeadId, updateSalesLeadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesApiApi.salesApiUpdateSalesLeadById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesApiApi - factory interface
 */
export const SalesApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesApiApiFp(configuration)
    return {
        /**
         * 
         * @param {SalesApiApiSalesApiCreateBulkSalesLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateBulkSalesLead(requestParameters: SalesApiApiSalesApiCreateBulkSalesLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBulkSalesLeadResponse> {
            return localVarFp.salesApiCreateBulkSalesLead(requestParameters.createSalesLeadBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiCreateCallAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateCallAttempt(requestParameters: SalesApiApiSalesApiCreateCallAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCallAttemptResponse> {
            return localVarFp.salesApiCreateCallAttempt(requestParameters.salesLeadId, requestParameters.createCallAttemptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiCreateSalesLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiCreateSalesLead(requestParameters: SalesApiApiSalesApiCreateSalesLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSalesLeadResponse> {
            return localVarFp.salesApiCreateSalesLead(requestParameters.createSalesLeadBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiDeleteSalesLeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiDeleteSalesLeadById(requestParameters: SalesApiApiSalesApiDeleteSalesLeadByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.salesApiDeleteSalesLeadById(requestParameters.salesLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiEmailToSalesLeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiEmailToSalesLead(requestParameters: SalesApiApiSalesApiEmailToSalesLeadRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalesLeadSignUpResponse> {
            return localVarFp.salesApiEmailToSalesLead(requestParameters.salesLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetCallAttemptListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetCallAttemptList(requestParameters: SalesApiApiSalesApiGetCallAttemptListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCallAttemptListResponse> {
            return localVarFp.salesApiGetCallAttemptList(requestParameters.page, requestParameters.pageSize, requestParameters.phoneNumber, requestParameters.salesLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesExcutiveListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesExcutiveList(requestParameters: SalesApiApiSalesApiGetSalesExcutiveListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetsalesExecutiveListResponse> {
            return localVarFp.salesApiGetSalesExcutiveList(requestParameters.name, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesExecRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesExec(requestParameters: SalesApiApiSalesApiGetSalesExecRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSalesExcutiveSub> {
            return localVarFp.salesApiGetSalesExec(requestParameters.salesUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesLeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadById(requestParameters: SalesApiApiSalesApiGetSalesLeadByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSalesLeadResponse> {
            return localVarFp.salesApiGetSalesLeadById(requestParameters.salesLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesLeadJobDetailsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadJobDetailsList(requestParameters: SalesApiApiSalesApiGetSalesLeadJobDetailsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllSalesLeadsJobsResponse> {
            return localVarFp.salesApiGetSalesLeadJobDetailsList(requestParameters.salesLeadId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesLeadListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesLeadList(requestParameters: SalesApiApiSalesApiGetSalesLeadListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllSalesLeadsResponse> {
            return localVarFp.salesApiGetSalesLeadList(requestParameters.maxDate, requestParameters.minDate, requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.salesLeadType, requestParameters.salesUserId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiGetSalesMailSentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiGetSalesMailSentList(requestParameters: SalesApiApiSalesApiGetSalesMailSentListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSalesMailSentListResponse> {
            return localVarFp.salesApiGetSalesMailSentList(requestParameters.email, requestParameters.page, requestParameters.pageSize, requestParameters.salesLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiUpdateCallAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiUpdateCallAttempt(requestParameters: SalesApiApiSalesApiUpdateCallAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCallAttemptResponse> {
            return localVarFp.salesApiUpdateCallAttempt(requestParameters.callAttemptId, requestParameters.salesLeadId, requestParameters.createCallAttemptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesApiApiSalesApiUpdateSalesLeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesApiUpdateSalesLeadById(requestParameters: SalesApiApiSalesApiUpdateSalesLeadByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSalesLeadResponse> {
            return localVarFp.salesApiUpdateSalesLeadById(requestParameters.salesLeadId, requestParameters.updateSalesLeadBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for salesApiCreateBulkSalesLead operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiCreateBulkSalesLeadRequest {
    readonly createSalesLeadBody: Array<CreateSalesLeadBody>
}

/**
 * Request parameters for salesApiCreateCallAttempt operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiCreateCallAttemptRequest {
    readonly salesLeadId: string

    readonly createCallAttemptBody: CreateCallAttemptBody
}

/**
 * Request parameters for salesApiCreateSalesLead operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiCreateSalesLeadRequest {
    readonly createSalesLeadBody: CreateSalesLeadBody
}

/**
 * Request parameters for salesApiDeleteSalesLeadById operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiDeleteSalesLeadByIdRequest {
    readonly salesLeadId: string
}

/**
 * Request parameters for salesApiEmailToSalesLead operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiEmailToSalesLeadRequest {
    readonly salesLeadId: string
}

/**
 * Request parameters for salesApiGetCallAttemptList operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetCallAttemptListRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly phoneNumber?: string

    readonly salesLeadId?: string
}

/**
 * Request parameters for salesApiGetSalesExcutiveList operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesExcutiveListRequest {
    readonly name?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for salesApiGetSalesExec operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesExecRequest {
    readonly salesUserId?: string
}

/**
 * Request parameters for salesApiGetSalesLeadById operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesLeadByIdRequest {
    readonly salesLeadId: string
}

/**
 * Request parameters for salesApiGetSalesLeadJobDetailsList operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesLeadJobDetailsListRequest {
    readonly salesLeadId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for salesApiGetSalesLeadList operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesLeadListRequest {
    readonly maxDate?: string

    readonly minDate?: string

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string

    readonly salesLeadType?: string

    readonly salesUserId?: string

    readonly status?: string
}

/**
 * Request parameters for salesApiGetSalesMailSentList operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiGetSalesMailSentListRequest {
    readonly email?: string

    readonly page?: number

    readonly pageSize?: number

    readonly salesLeadId?: string
}

/**
 * Request parameters for salesApiUpdateCallAttempt operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiUpdateCallAttemptRequest {
    readonly callAttemptId: string

    readonly salesLeadId: string

    readonly createCallAttemptBody: CreateCallAttemptBody
}

/**
 * Request parameters for salesApiUpdateSalesLeadById operation in SalesApiApi.
 */
export interface SalesApiApiSalesApiUpdateSalesLeadByIdRequest {
    readonly salesLeadId: string

    readonly updateSalesLeadBody: UpdateSalesLeadBody
}

/**
 * SalesApiApi - object-oriented interface
 */
export class SalesApiApi extends BaseAPI {
    /**
     * 
     * @param {SalesApiApiSalesApiCreateBulkSalesLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiCreateBulkSalesLead(requestParameters: SalesApiApiSalesApiCreateBulkSalesLeadRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiCreateBulkSalesLead(requestParameters.createSalesLeadBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiCreateCallAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiCreateCallAttempt(requestParameters: SalesApiApiSalesApiCreateCallAttemptRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiCreateCallAttempt(requestParameters.salesLeadId, requestParameters.createCallAttemptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiCreateSalesLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiCreateSalesLead(requestParameters: SalesApiApiSalesApiCreateSalesLeadRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiCreateSalesLead(requestParameters.createSalesLeadBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiDeleteSalesLeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiDeleteSalesLeadById(requestParameters: SalesApiApiSalesApiDeleteSalesLeadByIdRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiDeleteSalesLeadById(requestParameters.salesLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiEmailToSalesLeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiEmailToSalesLead(requestParameters: SalesApiApiSalesApiEmailToSalesLeadRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiEmailToSalesLead(requestParameters.salesLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetCallAttemptListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetCallAttemptList(requestParameters: SalesApiApiSalesApiGetCallAttemptListRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetCallAttemptList(requestParameters.page, requestParameters.pageSize, requestParameters.phoneNumber, requestParameters.salesLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesExcutiveListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesExcutiveList(requestParameters: SalesApiApiSalesApiGetSalesExcutiveListRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesExcutiveList(requestParameters.name, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesExecRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesExec(requestParameters: SalesApiApiSalesApiGetSalesExecRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesExec(requestParameters.salesUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesLeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesLeadById(requestParameters: SalesApiApiSalesApiGetSalesLeadByIdRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesLeadById(requestParameters.salesLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesLeadJobDetailsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesLeadJobDetailsList(requestParameters: SalesApiApiSalesApiGetSalesLeadJobDetailsListRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesLeadJobDetailsList(requestParameters.salesLeadId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesLeadListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesLeadList(requestParameters: SalesApiApiSalesApiGetSalesLeadListRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesLeadList(requestParameters.maxDate, requestParameters.minDate, requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.salesLeadType, requestParameters.salesUserId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiGetSalesMailSentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiGetSalesMailSentList(requestParameters: SalesApiApiSalesApiGetSalesMailSentListRequest = {}, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiGetSalesMailSentList(requestParameters.email, requestParameters.page, requestParameters.pageSize, requestParameters.salesLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiUpdateCallAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiUpdateCallAttempt(requestParameters: SalesApiApiSalesApiUpdateCallAttemptRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiUpdateCallAttempt(requestParameters.callAttemptId, requestParameters.salesLeadId, requestParameters.createCallAttemptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesApiApiSalesApiUpdateSalesLeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public salesApiUpdateSalesLeadById(requestParameters: SalesApiApiSalesApiUpdateSalesLeadByIdRequest, options?: RawAxiosRequestConfig) {
        return SalesApiApiFp(this.configuration).salesApiUpdateSalesLeadById(requestParameters.salesLeadId, requestParameters.updateSalesLeadBody, options).then((request) => request(this.axios, this.basePath));
    }
}

